module.exports = __webpack_public_path__ + "static/media/IMG-9.ca1e37c7.jpg";